import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private socketService: SocketService
  ) { }

  login(email: string, password: string, type: any, apartment_type: string = '') {
    const payload: any = { username: email, password: password, type: type };
    if (type === 'apartment' && apartment_type) payload['apartment_type'] = apartment_type;
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/admin-login`, payload)
      .pipe(map(user => {
        localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
        localStorage.setItem(`${environment.appName}` + 'username', user.data.user.username);
        this.socketService.connect(user.data.access_token);
        return user;
      }));
  }

  logout() {
    localStorage.removeItem(`${environment.appName}` + 'user');
    this.socketService.disconnect();
    this.router.navigate(['/login']);
  }
  stafflogin(code: any, username: any, password: any, type: any, apartment_type: string = '') {
    const formData: any = {
      'code': code,
      'username': username,
      'password': password,
      'type': type,
      'isDriver': 0
    };
    if (type === 'apartment' && apartment_type) formData['apartment_type'] = apartment_type;
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-login`, formData)
      .pipe(map(user => {
        localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
        // localStorage.setItem(`${environment.appName}` + 'role_id', user.data.user.role_id);
        // localStorage.setItem(`${environment.appName}` + 'user_name', user.data.user.user_name);
        // localStorage.setItem(`${environment.appName}` + 'role_type', user.data.user.role_type);
        this.socketService.connect(user.data.access_token);
        return user;
      }));
  }

  ForgotPassword(type: any, username: string, ) {

    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/forgot-password`, { type: type, username: username})
      .pipe(map(user => {
       
        return user;
      }));
  }

    resetPassword(token: any, newPassword: string, ) {

    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reset-password`, { token: token, newPassword: newPassword})
      .pipe(map(user => {
       
        return user;
      }));
  }

  // 
    private userData = new BehaviorSubject<any>(null);

  setUser(data: any) {
    localStorage.setItem('userData', JSON.stringify(data));
    this.userData.next(data);
  }

  getUser() {
    const localData = localStorage.getItem('userData');
    if (localData) {
      this.userData.next(JSON.parse(localData));
    }
    return this.userData.asObservable();
  }
}
